/* tslint:disable */
import { Packing } from './packing';
import { PackingLayer } from './packing-layer';

/**
 */
export class ViewPackingLayer {
    packing?: Packing;
    packingLayers?: PackingLayer[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-packing-layer.ts